import { NavTrigger, DropdownWrap } from './NavTrigger';
import { ProductsMenu } from './ProductsMenu';
import { SolutionsMenu } from './SolutionsMenu';
import { LinkListMenu } from './LinkListMenu';
import { ResourcesMenu } from './ResourcesMenu';
import { companyLinks } from './navData';

export const DesktopNav = ({ activeDropdown, handleMouseEnter, handleMouseLeave, isActive }) => {
  const dropdown = (id, trigger, menu, align) => (
    <div className="relative" onMouseEnter={() => handleMouseEnter(id)} onMouseLeave={handleMouseLeave}>
      {trigger}
      <DropdownWrap
        open={activeDropdown === id}
        align={align}
        onMouseEnter={() => handleMouseEnter(id)}
        onMouseLeave={handleMouseLeave}
      >
        {menu}
      </DropdownWrap>
    </div>
  );

  return (
    <nav className="hidden lg:flex items-center gap-0.5">
      {dropdown('products',
        <NavTrigger to="/products" testId="nav-products" label="Products" hasDropdown
          active={isActive('/products') || isActive('/services')} dropdownOpen={activeDropdown === 'products'} />,
        <ProductsMenu />,
        'screen'
      )}

      {dropdown('solutions',
        <NavTrigger to="/solutions" testId="nav-solutions" label="Solutions" hasDropdown
          active={isActive('/solutions')} dropdownOpen={activeDropdown === 'solutions'} />,
        <SolutionsMenu />
      )}

      <NavTrigger to="/pricing" testId="nav-pricing" label="Pricing" active={isActive('/pricing')} />

      {dropdown('resources',
        <NavTrigger to="/resources" testId="nav-resources" label="Resources" hasDropdown
          active={isActive('/resources') || isActive('/docs') || isActive('/developers')} dropdownOpen={activeDropdown === 'resources'} />,
        <ResourcesMenu />,
        'right'
      )}

      {dropdown('company',
        <NavTrigger to="/about" testId="nav-company" label="Company" hasDropdown
          active={isActive('/about') || isActive('/why-daakyi') || isActive('/security')} dropdownOpen={activeDropdown === 'company'} />,
        <LinkListMenu items={companyLinks} testIdPrefix="dropdown-co" accent="green" width="w-[320px]" />,
        'right'
      )}
    </nav>
  );
};
